import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateFuelingServiceOperationHours } from '../../api/fueling-service.ts';
import { UpdateFuelingServiceOperationHoursRequest } from '../../api/requests/fueling-service-request.ts';

export default function useUpdateFuelingServiceOperationHours(): UseMutationResult<
  Awaited<ReturnType<typeof updateFuelingServiceOperationHours>>,
  Error,
  UpdateFuelingServiceOperationHoursRequest
> {
  return useMutation({
    mutationFn: updateFuelingServiceOperationHours,
  });
}
